"use strict";
exports.__esModule = true;
exports.queued = void 0;
var utils_1 = require("../utils");
function queued(api, delayBetweenRuns) {
    if (delayBetweenRuns === void 0) { delayBetweenRuns = 100; }
    var q = (0, utils_1.asyncQueue)({
        delayBetweenRuns: delayBetweenRuns
    });
    var proxy = new Proxy(api, {
        get: function (target, propKey, receiver) {
            var targetValue = Reflect.get(target, propKey, receiver);
            if (typeof targetValue === "function") {
                return function () {
                    var _this = this;
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return q.submit(function () { return targetValue.apply(_this, args); });
                };
            }
            else {
                return targetValue;
            }
        }
    });
    return proxy;
}
exports.queued = queued;
//# sourceMappingURL=queued.js.map